module.exports = __webpack_public_path__ + "img/icon_gasoline_on.35b2ca7f.png";